{
  "fr": {
    "validation": {
      "emailAddressDemo": "L'adresse email d'un contact dans ce client démo doit se terminer par '{email_address_suffix}' ou '{'@'}ziggu.io'",
      "emailTaken": "L'adresse email a déjà été utilisée",
      "errorsInLanguages": "Certaines traductions contiennent des erreurs, veuillez vérifier : {languages}",
      "fix_errors": "Échec de l'enregistrement, veuillez corriger les erreurs",
      "import": {
        "inclusion": "Erreur dans la ligne {rowNumber} colonne {columnNumber} : {headerName} n'est pas inclus dans la liste",
        "inclusion_values": "avec les valeurs autorisées : {values}",
        "invalid": "Erreur dans la ligne {rowNumber} colonne {columnNumber} : {headerName} n'est pas valide",
        "required": "Erreur dans la ligne {rowNumber} colonne {columnNumber} : une valeur pour {headerName} est requise",
        "unique": "Erreur dans la ligne {rowNumber} : {headerName} n'est pas unique, il existe une autre ligne avec cette valeur"
      },
      "nameAlreadyTaken": "Le titre est déjà utilisé",
      "needCompany": "L'entreprise est requis",
      "needName": "Le nom est requis"
    }
  }
}
